<template>
  <div
    class="flex items-center gap-2 self-stretch rounded-lg bg-gray-100 p-[16px_14px] shadow-sm shadow-gray-500"
  >
    <div class="flex flex-[1_0_0] items-center gap-2">
      <div class="flex-[1_0_0] text-sm">{{ t('common.sixteenDigitCardNumber') }}</div>
      <div
        class="flex h-[24px] w-[34px] items-center justify-center rounded border-solid border-gray-100"
      >
        <MasterCardIcon></MasterCardIcon>
      </div>
    </div>
  </div>
  <div
    class="flex min-w-[192px] flex-wrap content-start items-start justify-between gap-6 self-stretch"
  >
    <div
      class="flex flex-[1_0_0] items-center gap-2 self-stretch rounded-lg bg-gray-100 p-[16px_14px] shadow-sm shadow-gray-500"
    >
      <div class="text-sm">{{ t('common.mmYy') }}</div>
    </div>
    <div
      class="flex flex-[1_0_0] items-center gap-2 self-stretch rounded-lg bg-gray-100 p-[16px_14px] shadow-sm shadow-gray-500"
    >
      <div class="flex w-[100%] justify-between gap-2">
        <div class="text-sm">{{ t('common.cvc') }}</div>
        <PaymentMethod class="h-[24px] w-[34px]"></PaymentMethod>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import MasterCardIcon from "@/assets/icons/mastercard.svg";
import PaymentMethod from "@/assets/icons/payment-method.svg";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
